import type { User } from '../../api/users'
import { Card, Rows } from './Card'
import { EditableSetting } from './EditableSetting'
import { PasswordSetting } from './PasswordSetting'
import { required, SettingRow } from './Setting'
import { useUpdateUser } from './useUpdateUser'

interface AccountSectionProps {
  parent: User
}

/** The parent's own record: a name they can change, an email they cannot, a password. */
export function AccountSection({ parent }: AccountSectionProps) {
  const update = useUpdateUser(parent)

  return (
    <Card
      header={<h2 className="text-2xl font-bold tracking-tight text-ink">Your Account</h2>}
      testId="account-section"
    >
      <Rows>
        <EditableSetting
          label="Name"
          value={parent.name}
          editLabel="Edit your name"
          save={(name) => update.mutateAsync({ name })}
          validate={required('Enter your name.')}
          field={{ autoComplete: 'name' }}
          testId="setting-name"
        />
        <SettingRow
          label="Email"
          value={parent.email}
          helper="This is the email you sign in with. To change it, contact support."
          testId="setting-email"
        />
        <PasswordSetting user={parent} own testId="setting-password" />
      </Rows>
    </Card>
  )
}
